import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: 'MOV', label: 'Movimentação' },
			{ value: 'RESUP', label: 'Ressuprimento' },
			{ value: 'INV', label: 'Inventário' },
			{ value: 'BLOQ', label: 'Bloqueio' },
			{ value: 'UNPICK', label: 'Unpick' },
			{ value: 'AUDIT_NAO_LOCALIZADO', label: 'Auditoria: produto não localizado' },
			{ value: 'AUDIT_QTD_DIVERGENTE', label: 'Auditoria: quantidade divergente' },
			{ value: 'AUDIT_POSICAO_INCORRETA', label: 'Auditoria: posição incorreta' },
			{ value: 'AUDIT_RESERVA_ORFA', label: 'Auditoria: reserva órfã' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}
